import { AUTHORIZATION_HEADER } from '../../../../../../../src/authorization';
import { send } from '../../../../../../../src/network';

export type Params = {
  customer_id: number;
  id: number;
};

export async function deleteApiV2CustomersCustomerIdProductRatingsId(
  params: Params
) {
  return await send<void>({
    path: `/api/v2/customers/${params.customer_id}/product_ratings/${params.id}/`,
    method: 'DELETE',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
